export enum Theme {
    Kraken = 'kraken',
    Light = 'light',
    Dark = 'dark'
}

export enum HamburgerMenuStyleGroups {
    Expanded = 'expanded',
    Collapsed = 'collapsed'
}

export enum AppPage {
    Graphs = 'graphs-page',
    DataPusher = 'data-pusher',
    Scene3D = 'scene-3D',
    Tools = 'tools',
    OntologyDesigner = 'ontology-designer'
}
